import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-learning-science',
  templateUrl: './learning-science.component.html',
  styleUrls: ['./learning-science.component.scss'],
  standalone: false,
})
export class LearningScienceComponent {
  @Input() title = 'The Impact of Learning Science';
  @Input() subtitle = 'Empower student success with evidence-based product experiences';
  @Input() ctaText = 'See the Research';
  @Input() ctaLink = 'https://www.macmillanlearning.com/college/us/learning-science';
  @Input() backgroundImage =
    'https://prod-cat-files.macmillan.cloud/MediaResources/instructorcatalog/college/common/callouts-homepage/learning-science-research-image.jpg';
}
